module.exports = __webpack_public_path__ + "static/img/product.959472b0.png";